import moment from 'moment';

export default class DateRangeService
{
	constructor($http)
	{
		this.$http = $http;

		// Set default date range
		this.startDate = moment().subtract(330, 'days');
		this.endDate = moment().subtract(300, 'days');
		this.compareStartDate = moment().subtract(330, 'days').subtract(1, 'year');
		this.compareEndDate = moment().subtract(300, 'days').subtract(1, 'year');
	}

	get startDate()
	{
		return this._startDate;
	}
	set startDate(startDate)
	{
		if (!startDate instanceof moment) {
			throw new TypeError('startDate is not an object of moment');
		}
		this._startDate = startDate;
	}

	get endDate()
	{
		return this._endDate;
	}
	set endDate(endDate)
	{
		if (!endDate instanceof moment) {
			throw new TypeError('endDate is not an object of moment');
		}
		this._endDate = endDate;
	}

	get compareStartDate()
	{
		return this._compareStartDate;
	}
	set compareStartDate(compareStartDate)
	{
		if (!compareStartDate instanceof moment) {
			throw new TypeError('compareStartDate is not an object of moment');
		}
		this._compareStartDate = compareStartDate;
	}

	get compareEndDate()
	{
		return this._compareEndDate;
	}
	set compareEndDate(compareEndDate)
	{
		if (!compareEndDate instanceof moment) {
			throw new TypeError('compareEndDate is not an object of moment');
		}
		this._compareEndDate = compareEndDate;
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/services/daterange.service.js
 **/